import type { ChromeExtensionSelectionMode } from '@prisma/client';

export const CHROME_EXTENSION_SELECTION_MODE_OPTIONS: { value: ChromeExtensionSelectionMode; label: string }[] = [
  { value: 'LATEST', label: 'Use latest version' },
  { value: 'PINNED', label: 'Pin to a version' },
];
